//CODE_START
import { createResourceStore } from "@/lib/resource";
import type { Business } from "./Business";

import type { Shop } from "./Shop";
import type { Order } from "./Order";

export interface Customer {
  id: number;
  name: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  address: string;
  city: string;
  region: string;
  country: string;
  debtAmount: string;
  date_of_birth: string | null;
  owing: number;
  segment_id: number | null;
  business_id: number | null;
  shop_id: number | null;
  type: string;
  business?: Business;
  shop?: Shop;
  orders?: Order[];
  created_at?: string;
  updated_at?: string;
}

export const getCustomerFullName = (customer: Customer) => {
  return `${customer.first_name} ${customer.last_name}`;
};

export const useCustomer = createResourceStore<Customer>("customers", () => ({
  transform: (item: Customer) => {
    return {
      ...item,
      name: `${item.first_name} ${item.last_name}`,
    };
  },
}));
//CODE_END
